import React, {Component} from 'react';
import {connect} from 'react-redux';

import conf from '../../../../conf.js';
import {isAdmin} from '../../../../../shared/services/userService.js';

class Phone extends Component {
  render() {
    if (this.props.isAdmin && this.props.user) {
      return <a
        href={`tel:${this.props.user?.tel ?? ''}`}
        className="data"
      >
        {this.props.user?.tel ?? 'Pas de téléphone'}
      </a>;
    }

    return <a href={`tel:${conf.site.phone}`} className="data">{conf.site.phone}</a>;
  }
}

export default connect(
  state => ({
    currentUser: state.currentUser.user,
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  })
)(Phone);